import React, {
  Fragment,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button, Form, Row, Col, Table } from "react-bootstrap";
import { Oval } from "react-loader-spinner";
import { createCourseWithDSULink, newCourseWithDSULink } from "../../lib/api/course";

// --------------------------------------------------------------------
//
//
//
// --------------------------------------------------------------------
const Loading = () => {
  return (
    <Oval
      height={80}
      width={80}
      color="#4fa94d"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
      ariaLabel="oval-loading"
      secondaryColor="#4fa94d"
      strokeWidth={2}
      strokeWidthSecondary={2}
    />
  );
};

// --------------------------------------------------------------------
//
//  Select File Component
//
// --------------------------------------------------------------------
const SelectFileComponent = ({ selectFile, onFileChange }) => {
  const fileInput = useRef();
  const handleButtonClick = (e) => {
    fileInput.current.click();
  };

  const fromOracleButtonClick = (e) => {
    // 오라클에서 학생과 교수 정보 가져와서 biggame Database 마이그래이션 
    console.log("학적정보 가져오기");
  }

  const handleChange = (e) => {
    //console.log(e.target.files[0]);
    onFileChange(e.target.files.length > 0 ? e.target.files[0] : null);
  };

  return (
    <Fragment>
      <Form>
        <Form.Label>
          {selectFile === null ? "파일을 선택하세요." : selectFile.name}
        </Form.Label>
        <Button className="ms-2" onClick={handleButtonClick}>
          파일 업로드
        </Button>
        
        <input
          type="file"
          style={{ display: "none" }}
          ref={fileInput}
          onChange={handleChange}
        />
      </Form>
      <Button className="ms-2" onClick={fromOracleButtonClick}> 학적 정보 가져오기 </Button>
    </Fragment>
  );
};

// --------------------------------------------------------------------
//
//  Link Form
//
// --------------------------------------------------------------------

const LinkInfoComponent = ({ classInfo }) => {
  return (
    <Fragment>
      <Row>
        <Col md="1">수업</Col>
        {classInfo === null ? (
          <Col>없음</Col>
        ) : (
          <Col>
            <Form>
              <Form.Group>
                <Form.Label className="me-3">
                  {classInfo.courseNumber}
                </Form.Label>
                <Form.Label>{classInfo.courseName}</Form.Label>
              </Form.Group>
            </Form>
          </Col>
        )}
      </Row>
    </Fragment>
  );
};

const LinkProfessorsComponent = ({ professors }) => {
  const professorItem = professors.map((x, index) => {
    return (
      <Form.Group key={index}>
        <Form.Label className="me-3">{x.id}</Form.Label>
        <Form.Label>{x.name}</Form.Label>
      </Form.Group>
    );
  });

  return (
    <Fragment>
      <Row>
        <Col md="1">교수</Col>
        {professors === null ? (
          <Col>없음</Col>
        ) : (
          <Col>
            <Form>{professorItem}</Form>
          </Col>
        )}
      </Row>
    </Fragment>
  );
};

const LinkStudentsComponent = ({ students }) => {
  const column_max = 5;

  let rowHeader = [];
  for (let i = 0; i < column_max; i++) {
    rowHeader.push(
      <Fragment key={i}>
        <th>아이디</th>
        <th>이름</th>
      </Fragment>
    );
  }

  let rowStudents = [];
  if (students) {
    let temp = [];
    for (let i = 0; i < students.length; i += column_max) {
      temp.push(students.slice(i, i + column_max));
    }

    rowStudents = temp.map((it, index) => {
      return (
        <Fragment key={index}>
          <tr>
            {it.map((st, sIndex) => {
              return (
                <Fragment key={sIndex}>
                  <td>{st.id}</td>
                  <td>{st.name}</td>
                </Fragment>
              );
            })}
          </tr>
        </Fragment>
      );
    });
  } else {
    return <Fragment></Fragment>;
  }

  return (
    <Fragment>
      <Row>
        <Col md="1">학생({students.length})</Col>
        {students === null ? (
          <Col>없음</Col>
        ) : (
          <Col>
            <Table variant="striped">
              <thead>
                <tr>{rowHeader}</tr>
              </thead>
              <tbody>{rowStudents}</tbody>
            </Table>
          </Col>
        )}
      </Row>
    </Fragment>
  );
};

// --------------------------------------------------------------------
//
//  Home
//
// --------------------------------------------------------------------
const Home = () => {
  const [activeButton, SetActiveButton] = useState(false);
  const [selectFile, SetSelectFile] = useState(null);
  const [classInfo, setClassInfo] = useState(null);
  const [professors, setProfessors] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectFile !== null) {
      SetActiveButton(true); 

      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        const content = e.target.result;
        const result = JSON.parse(content);
        //console.log(result);

        const year = 2023;
        const semester = 2;

        setClassInfo({
          year: year,
          semester: semester,
          courseNumber: year + "0" + semester + result.className,
          courseName: "디자인과창의적발상(어드벤처디자인)",
          classRoom: "1반",
          classHour: [10, 12],
        });
        setProfessors(result.professor);
        setStudents(result.students);
      };
      fileReader.readAsText(selectFile, "UTF-8");
    }

    //JSON.parse(jsonData));
    //console.log(JSON.parse(selectFile));
  }, [selectFile]);

  const handleModifyStudent = async () => {
    if (window.confirm("정말 수업을 생성하시겠습니까?")) {
      console.log("학생 추가하기 ");
      SetActiveButton(false);
      setLoading(true);
      const rsp = await newCourseWithDSULink(); 
      SetActiveButton(true);
        setLoading(false);

      if (rsp.status === 409) {
        alert(
          `수업은 이미 있습니다.(생성 실패)`
        );
      } else if (rsp.status === 201) {
        alert(
          `수업이 새로이 생성이 되었습니다.(생성 성공)`
        );
      }
    }
  }

  const handleCreateCourse = async () => {
    if (window.confirm("정말 수업을 생성하시겠습니까?")) {
      //alert("현재는 지원하지 않습니다.");
      SetActiveButton(false);
      setLoading(true);
      const rsp = await createCourseWithDSULink({
        info: classInfo,
        professor: professors[0],
        students: students,
      });
      //console.log(rsp);
      setLoading(false);

      const courseNumber = classInfo.courseNumber.slice(6, 9);
      const professorName = professors[0].name;
      if (rsp.status === 409) {
        alert(
          `${professorName}의 ${courseNumber} 수업은 이미 있습니다.(생성 실패)`
        );
      } else if (rsp.status === 201) {
        alert(
          `${professorName}의 ${courseNumber} 수업이 새로이 생성이 되었습니다.(생성 성공)`
        );
      }
    }
  };

  return (
    <div>
      <Container fluid="md">
        <br />
        <Button onClick={handleModifyStudent} >
        새로운 수업 생성
        </Button>
        {/* <Button onClick={handleModifyStudent} >        
        학생 변경 추가 삭제
        </Button> */}
        {/* <SelectFileComponent
          selectFile={selectFile}
          onFileChange={(file) => {
            SetSelectFile(file);
            SetActiveButton(file ?? false);
          }}
        /> */}
        {/* <hr />
        <LinkInfoComponent classInfo={classInfo} />
        <LinkProfessorsComponent professors={professors} />
        <LinkStudentsComponent students={students} />
        <hr /> */}
        <div className="loading">
          {loading ? (
            <Loading />
          ) : (
            <> 
            </> 
          )}
        </div>
        <br />
        <hr />
      </Container>
    </div>
  );
};

export default Home;
